import { render, staticRenderFns } from "./ListCardItem.vue?vue&type=template&id=bd140506"
import script from "./ListCardItem.vue?vue&type=script&lang=js"
export * from "./ListCardItem.vue?vue&type=script&lang=js"
import style0 from "./ListCardItem.vue?vue&type=style&index=0&id=bd140506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports